import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, Form, Input, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from "primereact/multiselect"
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import Modal from "react-bootstrap/Modal";
import { TreeSelect } from 'primereact/treeselect';
import { Eye, EyeOff } from 'lucide-react';
import { InputTextarea } from "primereact/inputtextarea"
import { setPageData } from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"

const Rolesadmin = ({ type }) => {
    const location = useLocation()
    const dispatch = useDispatch();
    const { first, rows, totalRecords } = useSelector(
        state => state.calendar.pagination
    )
    const dt = useRef(null);

    const queryParams = new URLSearchParams(location.search)
    const initialTabIndex = Number(queryParams.get("selectedTab")) || 0
    const [isGroupFormVisible, setIsGroupFormVisible] = useState(false)
    const [selectedOptions, setselectedOptions] = useState([])
    const [groupList, setGroupList] = useState([])
    const [availableOptions, setavailableOptions] = useState([])
    const [nodes, setNodes] = useState([])
    const [lazyParamsuser, setLazyParamsuser] = useState({ page: 0, rows: 10 });
    const [totalRecordsuser, setTotalRecordsuser] = useState(0);
      const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
        const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
        const [companyId, setCompanyId] = useState(intialcompanyId);
          const [companyId1, setCompanyId1] = useState();
    // Function to create a new node
    // const createNode = (parentId = null) => {
    //     const newNode = {
    //         key: Date.now().toString(),
    //         label: "",
    //         parentId,
    //         children: [],
    //     }

    //     if (!parentId) {
    //         setNodes([...nodes, newNode])
    //     } else {
    //         const updateNodes = nodesList => {
    //             return nodesList.map(node => {
    //                 if (node.key === parentId) {
    //                     return {
    //                         ...node,
    //                         children: [...(node.children || []), newNode],
    //                     }
    //                 }
    //                 if (node.children && node.children.length > 0) {
    //                     return {
    //                         ...node,
    //                         children: updateNodes(node.children),
    //                     }
    //                 }
    //                 return node
    //             })
    //         }
    //         setNodes(updateNodes(nodes))
    //     }
    // }

    // Function to update node label
    // const updateNodeLabel = (id, newLabel) => {
    //     const updateNodes = nodesList => {
    //         return nodesList.map(node => {
    //             if (node.key === id) {
    //                 return { ...node, label: newLabel }
    //             }
    //             if (node.children && node.children.length > 0) {
    //                 return {
    //                     ...node,
    //                     children: updateNodes(node.children),
    //                 }
    //             }
    //             return node
    //         })
    //     }
    //     setNodes(updateNodes(nodes))
    // }

    // Function to delete a node
    // const deleteNode = id => {
    //     const removeNode = nodesList => {
    //         return nodesList.filter(node => {
    //             if (node.key === id) {
    //                 return false
    //             }
    //             if (node.children && node.children.length > 0) {
    //                 node.children = removeNode(node.children)
    //             }
    //             return true
    //         })
    //     }
    //     setNodes(removeNode(nodes))
    // }

    // Recursive component to render the tree structure
    // const RenderNode = ({ node }) => {
    //     const [localLabel, setLocalLabel] = useState(node.label)

    //     const handleInputChange = e => {
    //         setLocalLabel(e.target.value) // Update local state
    //     }

    //     const handleInputBlur = () => {
    //         if (localLabel !== node.label) {
    //             updateNodeLabel(node.key, localLabel) // Update global state on blur
    //         }
    //     }

    //     return (
    //         <div className="ml-4">
    //             <div className="flex items-center gap-2 my-2">
    //                 <InputText
    //                     value={localLabel}
    //                     onChange={handleInputChange}
    //                     onBlur={handleInputBlur}
    //                     placeholder="Enter node label"
    //                     className="p-inputtext"
    //                 />
    //                 <Button
    //                     icon="pi pi-plus"
    //                     className="p-button-rounded p-button-success p-button-text"
    //                     onClick={() => createNode(node.key)}
    //                     tooltip="Add child node"
    //                 />
    //                 <Button
    //                     icon="pi pi-trash"
    //                     className="p-button-rounded p-button-danger p-button-text"
    //                     onClick={() => deleteNode(node.key)}
    //                     tooltip="Delete node"
    //                 />
    //             </div>
    //             {node.children && node.children.length > 0 && (
    //                 <div className="ml-4">
    //                     {node.children.map(childNode => (
    //                         <RenderNode key={childNode.key} node={childNode} />
    //                     ))}
    //                 </div>
    //             )}
    //         </div>
    //     )
    // }

    const [categoryNodes, setCategoryNodes] = useState([])
    // const createCategory = (parentCategoryId = null) => {
    //     const newCategory = {
    //         key: Date.now().toString(),
    //         label: "",
    //         parentCategoryId,
    //         children: [],
    //     }

    //     if (!parentCategoryId) {
    //         setCategoryNodes([...categoryNodes, newCategory])
    //     } else {
    //         const updateCategories = categoriesList => {
    //             return categoriesList.map(category => {
    //                 if (category.key === parentCategoryId) {
    //                     return {
    //                         ...category,
    //                         children: [...(category.children || []), newCategory],
    //                     }
    //                 }
    //                 if (category.children && category.children.length > 0) {
    //                     return {
    //                         ...category,
    //                         children: updateCategories(category.children),
    //                     }
    //                 }
    //                 return category
    //             })
    //         }
    //         setCategoryNodes(updateCategories(categoryNodes))
    //     }
    // }

    // const updateCategoryLabel = (id, newLabel) => {
    //     const updateCategories = categoriesList => {
    //         return categoriesList.map(category => {
    //             if (category.key === id) {
    //                 return { ...category, label: newLabel }
    //             }
    //             if (category.children && category.children.length > 0) {
    //                 return {
    //                     ...category,
    //                     children: updateCategories(category.children),
    //                 }
    //             }
    //             return category
    //         })
    //     }
    //     setCategoryNodes(updateCategories(categoryNodes))
    // }

    // const deleteCategory = id => {
    //     const removeCategory = categoriesList => {
    //         return categoriesList.filter(category => {
    //             if (category.key === id) {
    //                 return false
    //             }
    //             if (category.children && category.children.length > 0) {
    //                 category.children = removeCategory(category.children)
    //             }
    //             return true
    //         })
    //     }
    //     setCategoryNodes(removeCategory(categoryNodes))
    // }

    // const RenderCategory = ({ category }) => {
    //     const [localCategoryLabel, setLocalCategoryLabel] = useState(category.label)

    //     const handleInputChange = e => {
    //         setLocalCategoryLabel(e.target.value) // Update local state
    //     }

    //     const handleInputBlur = () => {
    //         if (localCategoryLabel !== category.label) {
    //             updateCategoryLabel(category.key, localCategoryLabel) // Update global state on blur
    //         }
    //     }

    //     return (
    //         <div className="ml-4">
    //             <div className="flex items-center gap-2 my-2">
    //                 <InputText
    //                     value={localCategoryLabel}
    //                     onChange={handleInputChange}
    //                     onBlur={handleInputBlur}
    //                     placeholder="Enter category label"
    //                     className="p-inputtext"
    //                 />
    //                 <Button
    //                     icon="pi pi-plus"
    //                     className="p-button-rounded p-button-success p-button-text"
    //                     onClick={() => createCategory(category.key)}
    //                     tooltip="Add child category"
    //                 />
    //                 <Button
    //                     icon="pi pi-trash"
    //                     className="p-button-rounded p-button-danger p-button-text"
    //                     onClick={() => deleteCategory(category.key)}
    //                     tooltip="Delete category"
    //                 />
    //             </div>
    //             {category.children && category.children.length > 0 && (
    //                 <div className="ml-4">
    //                     {category.children.map(childCategory => (
    //                         <RenderCategory
    //                             key={childCategory.key}
    //                             category={childCategory}
    //                         />
    //                     ))}
    //                 </div>
    //             )}
    //         </div>
    //     )
    // }

    const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
    const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
    const [isEditModegrop, setIsEditModegrop] = useState(null) // True when editing, false when adding


    const [isFormVisible, setIsFormVisible] = useState(false)
    const [isEditModeActive, setIsEditModeActive] = useState(false)
    const [userData, setUserData] = useState({
        roleNameField: "",
        creationDateField: "",
        actionField: "",
    })
    // Reset form data and hide form
    const resetFormFields = () => {
        setUserData({
            roleNameField: "",
            creationDateField: "",
            actionField: "",
        })
        setIsFormVisible(false)
        setaddrolespopup(false)
        setIsEditModeActive(false)
    }


    /////////////////////////////////////////////////////naveen pss////////////////////////////

    const [modulepermissions, setmodulepermissions] = useState([]);
    const { register: register2, formState: { errors: errors2 }, handleSubmit: handleSubmit2, getValues: getValues2, setValue: setValue2, trigger: trigger2, reset: reset2, } = useForm({ mode: "onBlur" });
    const [roleslist, setroleslist] = useState([]);
    const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
    const [selectedParent, setSelectedParent] = useState([]);
    const [selectedChildren, setSelectedChildren] = useState([]);
    const [actions, setActions] = useState({});

    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });

    // const [totalRecords, setTotalRecords] = useState(0);

    const [searchText, setSearchText] = useState('');
    const [smShow, setSmShow] = useState(false)
    const [smShowuser, setSmShowuser] = useState(false)
    const [smShowusergroup, setsmShowusergroup] = useState(false)
    const [smShowcreate, setSmShowcreate] = useState(false)
    const [smcreate, setsmcreate] = useState("Added")
    const [successAlert, setSuccessAlert] = useState(false);
    const [deleteRowId, setDeleteRowID] = useState(null)
    const [deleteRowIduser, setDeleteRowIDuser] = useState(null)
    const [errorhandling, seterrorhandling] = useState("")
    const [isEdited, setisEdited] = useState(false);
    const [isEditedgrp, setisEditedgrp] = useState(false);
    const [editId, setEditId] = useState(null);
    const [disable, setDisable] = useState(false);

      const onPageChangeuser = (event) => {
        
            const newPage = Math.floor(event.first / event.rows) + 1;
    
            dispatch(setPageData({
                first: event.first,
                rows: event.rows,
                totalRecords: totalRecords,
            })); 
            
            getAllrolesList(newPage, event.rows, type, companyId);
        };

    const getAllrolesList = async (page, size,type,companyId) => {

        // console.log(companyId,"companyIdcompanyIdcompanyId")

        try {
              setLoading(true);
            const response = await axios.get(`/api/v1/roles/?page=${page}&size=${size}&company_id=${companyId}`, {});
            if (response.data && response.data.results) {

                setroleslist(response.data.results);
                setTotalRecordsuser(response.data.count || 0); 
                dispatch(setPageData({
                    first: (page - 1) * size,
                    rows: size,
                    totalRecords: response.data.count || 0,
                }));

            }

        } catch (error) {
             setLoading(false); 
        } finally {
             setLoading(false); 
        }
    };
    useEffect(() => {
        const page = Math.floor(first / rows) + 1
        getAllrolesList(page, rows, type,companyId);

    }, [first, rows, type,companyId]);

    const getAllSublist = async () => {
        try {
            const response = await axios.get(`/api/v1/get-menu-data/`, {});
            if (response.data && response.data.results) {
                setmodulepermissions(response.data.results);
            }
        } catch (error) {
        }
    };
    const handleParentSelect1 = (parentId, subMenus) => {
        let updatedSelectedChildren = [...selectedChildren];
        let updatedActions = { ...actions };

        if (selectedParent.includes(parentId)) {
            // If parent is already selected, remove it and all its children
            updatedSelectedChildren = updatedSelectedChildren.filter(
                (id) => !subMenus.map((sub) => sub.menu_id).includes(id)
            );
            setSelectedParent(selectedParent.filter((id) => id !== parentId));
        } else {
            // If parent is selected, add all its children
            updatedSelectedChildren = [
                ...new Set([...updatedSelectedChildren, ...subMenus.map((sub) => sub.menu_id)]),
            ];
            setSelectedParent([...selectedParent, parentId]);
        }

        setSelectedChildren(updatedSelectedChildren);
        setActions(updatedActions);
    };
    // Handle Child Selection
    const handleChildSelect1 = (childId, parentId) => {
        let updatedSelectedChildren = [...selectedChildren];

        if (selectedChildren.includes(childId)) {
            // If child is selected, remove it
            updatedSelectedChildren = updatedSelectedChildren.filter((id) => id !== childId);
        } else {
            // If child is selected, add it and ensure parent is also selected
            updatedSelectedChildren.push(childId);
            if (!selectedParent.includes(parentId)) {
                setSelectedParent([...selectedParent, parentId]);
            }
        }

        // If no more children are selected, remove the parent
        const parentHasChildren = modulepermissions.find(
            (mod) => mod.menu_id === parentId
        )?.sub_menus?.some((sub) => updatedSelectedChildren.includes(sub.menu_id));

        if (!parentHasChildren) {
            setSelectedParent(selectedParent.filter((id) => id !== parentId));
        }

        setSelectedChildren(updatedSelectedChildren);
    };




    const getAllSublistupdate = async (id) => {
        try {
            const response = await axios.get(`/api/v1/roles/${id}/`);
            if (response.data) {
                let results = response.data;
                setCompanyId1(results.role_data.company);
                setValue1("roleName", results.role_data.role_name);
                setValue1("createdatesrole", moment(results.role_data.created_at).format("YYYY-MM-DD"));

                let permissions = results.permission_data || [];
                let parentPermissions = new Set();
                let childPermissions = new Set();
                let actionPermissions = {};

                permissions.forEach((permission) => {
                    const parentIds = permission.parent_id?.split(",").map(Number) || [];
                    const childIds = permission.child_id?.split(",").map(Number) || [];

                    const addIds = permission.add?.split(",").map(Number) || [];
                    const editIds = permission.edit?.split(",").map(Number) || [];
                    const deleteIds = permission.delete?.split(",").map(Number) || [];
                    const viewIds = permission.view?.split(",").map(Number) || [];

                    parentIds.forEach((pid) => parentPermissions.add(pid));
                    childIds.forEach((cid) => {
                        childPermissions.add(cid);

                        actionPermissions[cid] = {
                            add: addIds.includes(cid) ? "10" : "",
                            edit: editIds.includes(cid) ? "10" : "",
                            delete: deleteIds.includes(cid) ? "10" : "",
                            view: viewIds.includes(cid) ? "10" : "",
                        };
                    });
                });

                setSelectedParent(Array.from(parentPermissions));
                setSelectedChildren(Array.from(childPermissions));
                setActions(actionPermissions);
            }
        } catch (error) {
            console.error("Error in getAllSublistupdate", error);
        }
    };



    useEffect(() => {
        getAllSublist()
    }, [])


    const handleParentSelect = (parentId, subMenus) => {
        const childIds = subMenus.map((sub) => sub.menu_id);
        const isParentSelected = selectedParent.includes(parentId);

        const updatedSelectedParent = isParentSelected
            ? selectedParent.filter(id => id !== parentId)
            : [...selectedParent, parentId];

        const updatedSelectedChildren = isParentSelected
            ? selectedChildren.filter(id => !childIds.includes(id))
            : [...new Set([...selectedChildren, ...childIds])];

        const updatedActions = { ...actions };
        childIds.forEach(id => {
            if (isParentSelected) {
                delete updatedActions[id];
            } else {
                const hasActions = subMenus.find(sub => sub.menu_id === id)?.actions;
                if (hasActions) {
                    updatedActions[id] = { add: "10", edit: "10", delete: "10", view: "10" };
                }
            }
        });

        setSelectedParent(updatedSelectedParent);
        setSelectedChildren(updatedSelectedChildren);
        setActions(updatedActions);
    };

    const handleChildSelect = (childId, parentId) => {
        const isChildSelected = selectedChildren.includes(childId);
        const updatedSelectedChildren = isChildSelected
            ? selectedChildren.filter(id => id !== childId)
            : [...selectedChildren, childId];

        const updatedActions = { ...actions };
        if (isChildSelected) {
            delete updatedActions[childId];
        } else {
            updatedActions[childId] = { add: "10", edit: "10", delete: "10", view: "10" };
        }

        const parentSubMenus = modulepermissions.find(mod => mod.menu_id === parentId)?.sub_menus || [];
        const anyChildSelected = parentSubMenus.some(sub => updatedSelectedChildren.includes(sub.menu_id));

        const updatedSelectedParent = anyChildSelected
            ? selectedParent.includes(parentId)
                ? selectedParent
                : [...selectedParent, parentId]
            : selectedParent.filter(id => id !== parentId);

        setSelectedChildren(updatedSelectedChildren);
        setSelectedParent(updatedSelectedParent);
        setActions(updatedActions);
    };

    const handleActionSelect = (menuId, actionType) => {

        setActions((prev) => ({
            ...prev,
            [menuId]: {
                ...prev[menuId],
                [actionType]: prev[menuId]?.[actionType] === "10" ? "" : "10",
            },
        }));
    };
    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allParentIds = modulepermissions.map(mod => mod.menu_id);
            const allChildIds = modulepermissions.flatMap(mod => mod.sub_menus.map(sub => sub.menu_id));

            const newActions = {};
            modulepermissions.forEach(mod => {
                mod.sub_menus.forEach(sub => {
                    if (sub.actions) {
                        newActions[sub.menu_id] = {
                            add: "10",
                            edit: "10",
                            delete: "10",
                            view: "10"
                        };
                    }
                });
            });

            setSelectedParent(allParentIds);
            setSelectedChildren(allChildIds);
            setActions(newActions);
        } else {
            // Clear all
            setSelectedParent([]);
            setSelectedChildren([]);
            setActions({});
        }
    };


    const onSubmit = async (data) => {


        const req = {
            company : companyId1,
            role_name: data.roleName,
            createdatesrole: data.createdatesrole,
            parent_id: selectedParent.join(",") || "",
            child_id: selectedChildren.join(",") || "",

            add: selectedChildren
                .filter((id) => actions[id]?.add === "10")
                .join(",") || "",

            edit: selectedChildren
                .filter((id) => actions[id]?.edit === "10")
                .join(",") || "",

            delete: selectedChildren
                .filter((id) => actions[id]?.delete === "10")
                .join(",") || "",

            view: selectedChildren
                .filter((id) => actions[id]?.view === "10")
                .join(",") || "",
        };
        console.log(req)

        if (!isEdited) {
            try {
                var rolepost = await axios.post(`/api/v1/roles/`, req,);
                if (rolepost.data) {
                    setIsFormVisible(false)
                    setaddrolespopup(false)
                    const page = Math.floor(first / rows) + 1
                    getAllrolesList(page, rows, type,companyId);
                    setSmShowcreate(true)
                    setsmcreate("Added")
                }
                setLoading(false);
                setDisable(false)
            } catch (error) {
                setLoading(false);
                setDisable(false)
                if (error.response.data.error) {
                    seterrorhandling(error.response.data.error)
                }

            }
        } else {
            try {
                var response = await axios.put(`/api/v1/roles/${editId}/`, req,);
                if (response.data) {
                    setaddrolespopup(false)
                    const page = Math.floor(first / rows) + 1
                    getAllrolesList(page, rows, type,companyId);
                    setSmShowcreate(true)
                    setsmcreate("Edited")
                }
                setLoading(false);
                setDisable(false)
            } catch (error) {
                setLoading(false);
                setDisable(false)
                if (error.response.data.error) {
                    seterrorhandling(error.response.data.error)
                }
            }
        }
    };

    const deleteHandler = async () => {
        let id = deleteRowId
        await axios.delete(`/api/v1/roles/${id}/`)
            .then((resp) => {
                const page = Math.floor(first / rows) + 1
                getAllrolesList(page, rows, type,companyId);
                setSmShow(false)
                setSuccessAlert(true)
            })
            .catch((error) => {
            });
    }
    const [addrolespopup, setaddrolespopup] = useState(false)


    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };


     const handleCompanyChange = (company) => {
        // setSelectedCompany(company);
          const page = Math.floor(first / rows) + 1
        if (company?.company_id) {
            setCompanyId(company?.company_id);
            // getAllrolesList(page, rows, type,company?.company_id);
        }
    };

     const handleCompanyChange1 = (company) => {
        // setSelectedCompany(company);
          const page = Math.floor(first / rows) + 1
        if (company?.company_id) {
            setCompanyId1(company?.company_id);
            // getAllrolesList(page, rows, type,company?.company_id);
        }
    };
    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="">

                    <div className="container-fluid mt-3 ps-3">
                        <div className="usermanagement-main">
                            <div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="heading-sz">Roles</h3>

                                    {/* Add Role Button */}
                                    <div className="d-flex align-items-center justify-content-end">
                                        
                                        <div className="field mb-2 me-2" style={{ width: "200px"}}>
                                            <label className="me-2">Select Company <span className="text-danger">*</span></label>
                                            {/* <label htmlFor="role_id">Company<span className="text-danger">*</span></label> */}
                                            <CompanySelector onCompanyChange={handleCompanyChange} />
                                        </div>
                                        <div className="mb-3 mt-3">
                                            <Button
                                                label="Add Role"
                                                icon="pi pi-shield"
                                                className="p-button-primary btn btn-primary waves-effect" style={{ color: "white"}}
                                                onClick={() => {
                                                    // setIsFormVisible(true)
                                                    setaddrolespopup(true)
                                                    setisEdited(false)
                                                    reset1()
                                                    setSelectedParent([])
                                                    setSelectedChildren([])
                                                    setActions("")
                                                    setsmcreate("Added")

                                                }}
                                            /> 
                                        </div>
                                    </div>
                                    
                                </div>
                                {isFormVisible && (
                                    <div className="mb-3 p-3 border rounded">
                                        {/* <h4 className="heading-sz">{isEditModeActive ? "Edit Role" : "Add Role"}</h4> */}

                                        {/* Role Name Field */}
                                        <div className="field mb-2">
                                            <label htmlFor="roleNameField">Role Name</label>
                                            <InputText
                                                id="roleNameField"
                                                className="w-full"
                                                value={userData.roleNameField}
                                                onChange={e =>
                                                    setUserData({
                                                        ...userData,
                                                        roleNameField: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Create Date Field */}
                                        <div className="field mb-2">
                                            <label htmlFor="createDateField">
                                                Create Date
                                            </label>
                                            <InputText
                                                id="createDateField"
                                                className="w-full"
                                                value={userData.creationDateField}
                                                disabled // Make the field read-only
                                            />
                                        </div>

                                        {/* Copy Role Dropdown */}
                                        <div className="field mb-2">
                                            <label htmlFor="copyRoleField">Copy Role</label>
                                            <Dropdown
                                                id="copyRoleField"
                                                className="w-full"
                                                value={userData.copyRoleField}
                                                options={roleDataList.map(role => ({
                                                    label: role.roleNameField,
                                                    value: role.roleNameField,
                                                }))} // Create dropdown options from existing roles
                                                onChange={e =>
                                                    setUserData({
                                                        ...userData,
                                                        copyRoleField: e.value,
                                                    })
                                                }
                                                placeholder="Select a role to copy"
                                            />
                                        </div>

                                        {/* Permissions Section */}
                                        <div className="mb-3">
                                            <h5 className="heading-sz mt-3">
                                                Module Permissions
                                            </h5>

                                            {/* Candidates Section */}
                                            <div className="mb-3 p-3 border rounded">
                                                <h6 className="heading-szm">Candidates</h6>

                                                <Row className="d-flex flex-wrap">
                                                    {/* <div > */}
                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="addCandidate"
                                                                className="form-check-input"
                                                                checked={permissions.addCandidate}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        addCandidate: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="addCandidate"
                                                            >
                                                                Add Candidate
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="deleteCandidate"
                                                                className="form-check-input"
                                                                checked={permissions.deleteCandidate}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        deleteCandidate: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="deleteCandidate"
                                                            >
                                                                Delete Candidate
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="editCandidate"
                                                                className="form-check-input"
                                                                checked={permissions.editCandidate}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        editCandidate: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="editCandidate"
                                                            >
                                                                Edit Candidate
                                                            </label>
                                                        </div>
                                                    </Col>
                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllCandidates"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllCandidates}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllCandidates: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllCandidates"
                                                            >
                                                                View All Candidates
                                                            </label>
                                                        </div>
                                                    </Col>
                                                    <Col xl={6}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllCandidates"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllCandidates}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllCandidates: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllCandidates"
                                                            >
                                                                View Only Created by Me
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    {/* </div> */}
                                                </Row>
                                            </div>

                                            {/* Jobs Section */}
                                            <div className="mb-3 p-3 border rounded">
                                                <h6 className="heading-szm">Jobs</h6>

                                                <Row className="flex-wrap">
                                                    {/* <div> */}

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="addJob"
                                                                className="form-check-input"
                                                                checked={permissions.addJob}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        addJob: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="addJob"
                                                            >
                                                                Add Job
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="deleteJob"
                                                                className="form-check-input"
                                                                checked={permissions.deleteJob}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        deleteJob: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="deleteJob"
                                                            >
                                                                Delete Job
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="editJob"
                                                                className="form-check-input"
                                                                checked={permissions.editJob}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        editJob: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="editJob"
                                                            >
                                                                Edit Job
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllJobs"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllJobs}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllJobs: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllJobs"
                                                            >
                                                                View All Jobs
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllCandidates"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllCandidates}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllCandidates: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllCandidates"
                                                            >
                                                                View Only Created by Me
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    {/* </div> */}
                                                </Row>
                                            </div>

                                            {/* Interviews Section */}
                                            <div className="mb-3 p-3 border rounded">
                                                <h6 className="heading-szm">Interviews</h6>

                                                <Row className="flex-wrap">
                                                    {/* <div> */}

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="scheduleInterview"
                                                                className="form-check-input"
                                                                checked={permissions.scheduleInterview}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        scheduleInterview: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="scheduleInterview"
                                                            >
                                                                Schedule Interview
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="cancelInterview"
                                                                className="form-check-input"
                                                                checked={permissions.cancelInterview}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        cancelInterview: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="cancelInterview"
                                                            >
                                                                Cancel Interview
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="editInterview"
                                                                className="form-check-input"
                                                                checked={permissions.editInterview}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        editInterview: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="editInterview"
                                                            >
                                                                Edit Interview
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check me-3">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllInterviews1"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllInterviews}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllInterviews1:
                                                                            e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllInterviews1"
                                                            >
                                                                View All Interviews
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    <Col xl={6}>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="viewAllCandidates"
                                                                className="form-check-input"
                                                                checked={permissions.viewAllCandidates}
                                                                onChange={e =>
                                                                    setPermissions({
                                                                        ...permissions,
                                                                        viewAllCandidates: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="viewAllCandidates"
                                                            >
                                                                View Only Created by Me
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    {/* </div> */}
                                                </Row>
                                            </div>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="d-flex justify-content-start mt-3">
                                            <Button
                                                label={isEditModeActive ? "Update" : "Save"}
                                                icon="pi pi-save"
                                                className="p-button-primary me-2"
                                            // onClick={handleFormSubmission}
                                            />
                                            <Button
                                                label="Cancel"
                                                icon="pi pi-times"
                                                className="p-button-danger"
                                                onClick={resetFormFields} // Cancel action will reset and hide the form
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* DataTable Section */}
                                {loading ? (
                                                                 
                                    <OrgTableShimmer columns={6} rows={7} titleWidth="210px" />
                                ) : (

                                    <DataTable
                                        ref={dt}
                                        value={roleslist}
                                        dataKey="role_id"
                                        loading={loading}
                                        paginator
                                        lazy
                                        first={first}
                                        id="RolesList"
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        onPage={onPageChangeuser}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        rowsPerPageOptions={[5, 10, 20, 50, totalRecords]} 
                                    >
                                        <Column field="role_name" header="Role Name" />
                                        <Column field="created_at" header="Create Date" body={(rowData) => moment(rowData.created_at).format('DD-MM-YYYY')} />
                                        <Column field="type" header="Type" body={(rowData) => rowData.type?.charAt(0).toUpperCase() + rowData.type?.slice(1)} />

                                        {/* Actions Column for Edit and Delete */}
                                        <Column
                                            style={{ width: "10%" }}
                                            body={(rowData, { rowIndex }) => (
                                                <div className="d-flex">

                                                    {rowData?.type?.toLowerCase() === "system" ? (
                                                        <>
                                                            <Button
                                                                icon="pi pi-pencil"
                                                                className="p-button-text p-button-sm me-2"
                                                                disabled
                                                                onClick={() => {
                                                                    setaddrolespopup(true);
                                                                    setisEdited(true);
                                                                    setEditId(rowData?.role_id);
                                                                    getAllSublistupdate(rowData.role_id);
                                                                    setsmcreate("Edited")
                                                                }}
                                                            />
                                                            <Button
                                                                icon="pi pi-trash"
                                                                disabled
                                                                className="p-button-text p-button-sm p-button-danger"
                                                                onClick={() => {
                                                                    setSmShow(true);
                                                                    setDeleteRowID(rowData?.role_id);
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                        <div className="text-center border border-danger justify-content-center">
                                                            <Button
                                                                icon="pi pi-pencil"
                                                                className="p-button-text p-button-sm me-2"
                                                                onClick={() => {
                                                                    setaddrolespopup(true);
                                                                    setisEdited(true);
                                                                    setEditId(rowData?.role_id);
                                                                    getAllSublistupdate(rowData.role_id);
                                                                    reset1();
                                                                    setsmcreate("Edited")
                                                                }}
                                                            />
                                                            <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-text p-button-sm p-button-danger"
                                                                onClick={() => {
                                                                    setSmShow(true);
                                                                    setDeleteRowID(rowData?.role_id);
                                                                }}
                                                            />
                                                        </div>
                                                        </>
                                                    )}


                                                    {/* {rowData?.type == "System" ? (<Button icon="pi pi-pencil" className="p-button-text p-button-sm me-2"
                                                                onClick={() => { setaddrolespopup(true); setisEdited(true); setEditId(rowData?.role_id); getAllSublistupdate(rowData.role_id); reset1() }} />) : null}
                                                            {rowData?.type == "System" ? (
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="p-button-text p-button-sm p-button-danger"
                                                                    onClick={() => {
                                                                        setSmShow(true);
                                                                        setDeleteRowID(rowData?.role_id);
                                                                    }}
                                                                />
                                                            ) : null} */}
                                                </div>
                                            )}
                                            header="Actions"
                                        />
                                    </DataTable> 
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>

            <Dialog
                header="Roles"
                visible={addrolespopup}
                className="interview-popup"
                style={{ width: '50vw' }}
                onHide={() => { if (!addrolespopup) return; setaddrolespopup(false); }}>

                <div>
                    <form onSubmit={handleSubmit1(onSubmit)}>
                        <div className="mb-3 p-3 border rounded ">
                            {/* <h4 className="heading-sz">{isEditModeActive ? "Edit Role" : "Add Role"}</h4> */}
                            <div className="roleforms" style={{}}>
                                {/* Role Name Field */}
                                <div className="row">
                                    <div className="col-6">
                                        <div className="field mb-2">
                                            <label htmlFor="role_id">Company<span className="text-danger">*</span></label>
                                              <CompanySelector onCompanyChange={handleCompanyChange1}  selectedCompanyId={companyId1}/>
                                            {/* <Input className="mb-3" type="select" id="CompanySelInput" name="CompanySelInput">
                                                <option selected>Select Company</option>
                                                <option value="1">PSS</option>
                                                <option value="2">VGTS</option>
                                                <option value="3">Varun Digital</option>
                                                <option value="4">MSCD</option>
                                            </Input> */}
                                            {/* {errors.role_id && <small className="text-danger">{errors.role_id.message}</small>} */}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="field mb-2">
                                            <label htmlFor="roleNameField">Role Name</label>
                                            <InputText
                                                className="w-full"
                                                {...register1("roleName", {
                                                    required: "Role Name is required",
                                                    pattern: {
                                                        value: /^[A-Za-z&][A-Za-z-\s&]*$/,
                                                        message: "Please enter valid Role Name ",
                                                    },

                                                })} onKeyUp={() => { trigger1("roleName"); seterrorhandling("") }} />
                                            {errors1.roleName && (<small className='form-text text-danger'>{errors1.roleName.message}</small>)}

                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="row">
                                        <div className="col-6">
                                            <h5 className="heading-sz">Module Permissions</h5>
                                        </div>
                                        <div className="col-6 d-flex justify-content-end align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={selectedParent.length === modulepermissions.length}
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                                className="form-check-input"
                                            />
                                            <span className="ms-2 font-medium">Select All</span>
                                        </div>
                                    </div>


                                    {/* <div className="flex items-center mt-2">
                                      
                                    </div> */}
                                    {/* Candidates Section */}
                                    <div className="row" style={{ minHeight: "200px" }}>
                                        {modulepermissions.map((modulerole, index) => (
                                            <div className="col-12" key={index} >
                                                <div className="mb-3 p-3 border rounded">
                                                    <Row className="d-flex flex-wrap">
                                                        <div className="mt-3">
                                                            <label className="flex items-center space-x-2">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedParent.includes(modulerole.menu_id)}
                                                                    onChange={() => handleParentSelect(modulerole.menu_id, modulerole.sub_menus)}
                                                                    value={modulerole.menu_id}
                                                                    className="form-check-input"
                                                                />
                                                                <span className="font-medium ms-2">{modulerole.menu_name}</span>
                                                            </label>

                                                            <div className="grid grid-cols-2 gap-4 mt-2">
                                                                {modulerole.sub_menus?.length > 0 && (
                                                                    <div className="ml-4 mt-2">
                                                                        {modulerole.sub_menus.map((submenu, idx) => (
                                                                            <div key={idx} className="mt-2">
                                                                                <label className="flex items-center space-x-2">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectedChildren.includes(submenu.menu_id)}
                                                                                        onChange={() => handleChildSelect(submenu.menu_id, modulerole.menu_id)}
                                                                                        value={submenu.menu_id}
                                                                                        className="form-check-input"
                                                                                    />
                                                                                    <span className="font-medium ms-2">{submenu.menu_name}</span>
                                                                                </label>
                                                                                {submenu.actions && (
                                                                                    <div className="grid grid-cols-2 gap-4 mt-1 ml-4 pl-4 border-l">
                                                                                        {['add', 'edit', 'delete', 'view'].map(action => (
                                                                                            <label key={action} className="flex items-center space-x-2">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    checked={actions[submenu.menu_id]?.[action] || false}
                                                                                                    onChange={() => handleActionSelect(submenu.menu_id, action)}
                                                                                                />
                                                                                                <span className="ms-2">{action.charAt(0).toUpperCase() + action.slice(1)}</span>
                                                                                            </label>
                                                                                        ))}
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                        </div>
                        <small className='form-text text-danger'>{errorhandling}</small>
                        <div className="d-flex justify-content-end mt-3">
                            <Button type="button" label="Cancel" icon="pi pi-times" className="p-button-danger mr-3" onClick={resetFormFields} />
                            <Button type="submit" label="Save" icon="pi pi-save" className="p-button-danger mr-3" />
                            {/* <Button type='submit' icon="pi pi-save" className="p-button-primary me-2" >Save</Button> */}
                        </div>
                    </form>
                </div>

            </Dialog>
            <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
                </div>
            </Modal>
            <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
                <div className="text-center m-3"> </div>
                <h4 className="text-center">Deleted  Successfully</h4>
                <div className="text-center m-3">
                    <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
                </div>
            </Modal>



            <Modal size="md" show={smShowcreate} onHide={() => setSmShowcreate(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 ">{smcreate}</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> {smcreate} Successfully  </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShowcreate(false)} >ok</Button>

                </div>
            </Modal>

            
        </React.Fragment>
    )
}

export default Rolesadmin;